import { ThemeProvider } from '@cevop/ui';
import { Navigate, Route, Routes, useParams } from 'react-router-dom';
import { LOGIN_URL, SIGNUP_URL } from './config';
import { Layout } from './components/Layout';
import { AppRedirect } from './pages/AppRedirect';
import { AboutPage } from './pages/About';
import { BillingPage } from './pages/Billing';
import { BlogPage } from './pages/Blog';
import { BlogPostPage } from './pages/BlogPost';
import { BusinessPage } from './pages/Business';
import { ContactPage } from './pages/Contact';
import { FaqPage } from './pages/Faq';
import { GuidesPage } from './pages/Guides';
import { HelpArticlePage } from './pages/HelpArticle';
import { HelpIndexPage } from './pages/HelpIndex';
import { HomePage } from './pages/Home';
import { NotFoundPage } from './pages/NotFound';
import { PosPage } from './pages/Pos';
import { PricingPage } from './pages/Pricing';
import { PrivacyPage } from './pages/Privacy';
import { SecurityPage } from './pages/Security';
import { SolutionsPage } from './pages/Solutions';
import { StoriesPage } from './pages/Stories';
import { StoryPage } from './pages/Story';
import { TermsPage } from './pages/Terms';

export function App() {
  return (
    <ThemeProvider>
      <Layout>
        <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/signup" element={<AppRedirect href={SIGNUP_URL} label="Create account" />} />
        <Route path="/login" element={<AppRedirect href={LOGIN_URL} label="Sign in" />} />
        <Route path="/pos" element={<PosPage />} />
        <Route path="/business" element={<BusinessPage />} />
        <Route path="/pricing" element={<PricingPage />} />
        <Route path="/billing" element={<BillingPage />} />
        <Route path="/checkout" element={<Navigate to="/billing" replace />} />
        <Route path="/solutions" element={<SolutionsPage />} />
        <Route path="/help" element={<HelpIndexPage />} />
        <Route path="/help/:slug" element={<HelpArticleRoute />} />
        <Route path="/docs" element={<Navigate to="/help" replace />} />
        <Route path="/docs/:slug" element={<DocsRedirect />} />
        <Route path="/guides" element={<GuidesPage />} />
        <Route path="/faq" element={<FaqPage />} />
        <Route path="/blog" element={<BlogPage />} />
        <Route path="/blog/:slug" element={<BlogPostPage />} />
        <Route path="/stories" element={<StoriesPage />} />
        <Route path="/stories/:slug" element={<StoryPage />} />
        <Route path="/security" element={<SecurityPage />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/privacy" element={<PrivacyPage />} />
        <Route path="/terms" element={<TermsPage />} />
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
      </Layout>
    </ThemeProvider>
  );
}

function DocsRedirect() {
  const { slug } = useParams();
  if (!slug) return <Navigate to="/help" replace />;
  const next = slug === 'till' ? 'pos' : slug;
  return <Navigate to={`/help/${next}`} replace />;
}

function HelpArticleRoute() {
  const { slug } = useParams();
  if (!slug) return <Navigate to="/help" replace />;
  if (slug === 'till') return <Navigate to="/help/pos" replace />;
  return <HelpArticlePage slug={slug} />;
}
